<template>
  <div>
    <!-- {{ sortSel }} -->
    <!-- {{ activeChild }} -->
    <!-- {{ sortSel }} -->

    <div class="m-headWrap">
      <div style="width:500px;" class="colRed u-tip">
        Note: The order report only counts the data after the goods have been
        received, and does not count the data that has not been received.
      </div>
      <div class="m-head">
        <el-tabs v-model="activeChild" @tab-click="handleClick">
          <el-tab-pane v-for="(childItem, j) in childMenu" :name="childItem.value" :key="j">
            <span slot="label" class="fontWeight">{{ childItem.label }}</span>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <ul class="m-sortWarp">
      <li class=" clear">
        <span class="l colBlack">Order Status：</span>
        <ul class="u-stateBtn l clear">
          <template v-for="(item, i) in ['Processing', 'Finished']">
            <!-- <li
              :key="i"
              class="l"
              @click="sortSel.WaybillStatus = [1, 2][i]"
              :class="{ activeState: sortSel.WaybillStatus == [1, 2][i] }"
            >
              {{ item }}
            </li> -->
            <li :key="i" class="l" @click="swichOrder(i)" :class="{ activeState: sortSel.WaybillStatus.includes(i) }">
              {{ item }}
            </li>
          </template>
        </ul>
        <div class="clear u-sortBtn-list">
          <template v-for="(itemSort, i) in sortData">
            <div :key="i" class="u-sortBtn l">
              <!-- :style="'width:' + itemSort.width + 'px'" -->
              <u-sortSel :id="itemSort.value" :type="itemSort.type" :placeholder="itemSort.placeholder" v-model="sortSel[itemSort.value]" :allData="itemSort.options" :width="itemSort.width"></u-sortSel>
            </div>
          </template>
        </div>

        <div style="width: 100px;" slot="reference" class="exportBtn r marR30" @click="exportImg">
          <!-- <i class="fa">&#xe70a;</i> -->
          Download
        </div>
        <!-- <div class="exportBtn r marR30" @click="exportImg">
          <i class="fa">&#xe70a;</i> Download
        </div> -->
      </li>

      <li class="clear">
        <span class="l colBlack">Statistical indicators：</span>
        <div class="l" style="margin-right: 12px">
          <el-select style="width: 80px" class="font12" v-model="sortSel.indicators" placeholder="Total" :disabled="sumDisabble" @change="firstChange">
            <!-- <el-option
              class="font12"
              v-for="item in indicatorsOpt"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            > -->
            <el-option class="font12" v-for="item in indicatorsOpt" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="l">
          <!-- {{ isAva }} -->
          <!-- <el-select
            style="width: 130px"
            class="font12"
            v-model="sortSel.indicators1"
            placeholder="请选择"
          > -->

          <el-select style="width: 130px" class="font12" v-model="sortSel.indicators1" @change="indicaChange" placeholder="请选择">
            <el-option v-for="item in indicatorsOpt1" class="font12" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <ul class="u-stateBtn r clear marR30">
          <template v-for="(item, i) in ['Week', 'Month', 'Quarter', 'Year']">
            <li :key="i" class="l" @click="sortSel.dateState = [1, 2, 3, 4][i]" :class="{ activeState: sortSel.dateState == [1, 2, 3, 4][i] }">
              {{ item }}
            </li>
          </template>
        </ul>
      </li>
    </ul>
    <div id="exportpdf" ref="exportImg">
      <div v-for="(item, i) in getJson" :key="i">
        <div class="u-line" v-if="i !== 0"></div>
        <div class="m-fromWarp">
          <ul class="u-change clear">
            <li class="title l">
              {{
                [
                  secendMode("Logistics cost (USD)"),

                  secendMode("Logistics cost per kilo (usd/kg)"),

                  secendMode(
                    activeChild === "1,3,7,20"
                      ? "Total number of shipments (single)"
                      : "Proportion of freight and value of goods (no statistics for orders without value)"
                  )
                ][i]
              }}
            </li>
            <li v-if="i !== 2" class="change r clear">
              <span class="l label">Chart type：</span>
              <el-radio-group v-model="item.type">
                <el-radio class="l" label="bar">
                  <span class="checkLabel">Histogram</span>
                </el-radio>
                <el-radio v-if="sortSel.indicators === 'Total'" class="l" label="line">
                  <span class="checkLabel">Line chart</span>
                </el-radio>
                <el-radio class="l" label="pie">
                  <span class="checkLabel">Pie chart</span>
                </el-radio>
              </el-radio-group>
            </li>
          </ul>
          <div>
            <!-- <keep-alive> -->
            <by-charts :sortSel="sortSel" :deliveryNum="item.deliveryNum" :chartDatas="item.chartDatas" :id="'chart' + i" :ref="'chart' + i" :barWidth="item.barWidth" :type="item.type" :activeChild="activeChild"></by-charts>
            <!-- </keep-alive> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import byCharts from "./byCharts/byCharts.vue";
import uSortSel from "./uSortSel.vue";
import html2Canvas from "html2canvas";
import {
  fuzzyQuery,
  getCity,
  getContry,
  getAirport,
  getEcharts,
  conversionParameters,
  getStore,
  getStartAirport,
  filterTab
} from "./utils";

const defaultVal = {
  city: {}, //起运城市，
  country: {}, //目的国家
  consignee: {}, //收货人
  consignor: {}, //发货人
  amazon: {}, //AmazonWarehouse
  startAirport: {}, //起运机场
  endAirport: {}, //Destination airport
  WaybillStatus: [0, 1], //订单状态
  dateState: 1, //日期状态
  indicators: "Total", //第一个Statistical indicators
  indicators1: 1, //第二个Statistical indicators
  deliveryTm: {}, //DeliveryTime
  completeTm: {}
};
export default {
  name: "statement",
  components: { byCharts, uSortSel },
  data() {
    return {
      activeChild: "1,3,7,20",

      sortSel: JSON.parse(JSON.stringify(defaultVal)),

      firstStage: true, //第一级

      getJson: [], //图表数据
      sortData: [], // Filter数据

      // Statistical indicators
      indicatorsOpt: "",
      indicatorsOpt1: "",
      sumDisabble: false,
      fuzzyQuery
    };
  },

  // created() {},
  mounted() {
    this.getAjax();
    //console.log(22);
  },
  computed: {
    titleTime() {
      const map = {
        1: "Week",
        2: "Month",
        3: "Quarter",
        4: "Year"
      };
      return map[this.sortSel.dateState];
    },
    titleMode() {
      const map = {
        Total: "总",
        Average: "Average"
      };
      return map[this.sortSel.indicators];
    },

    childMenu() {
      return filterTab({
        Express: "1",
        Air: "3",
        FBA: "20",
        specialLine: "22"
      });
    }
  },
  watch: {
    // 监听Filter值得调用
    sortSel: {
      handler(newVal) {
        //console.log(newVal, "使用方法调用 获取最新得");
        this.getChartData();
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    secendMode(title) {
      if (this.sortSel.indicators1 === 1) return title;
      const map = {
        1: "",
        2: "prescription(after taking parts)",
        3: "prescription(after shipment)",
        4: "Declared value",
        5: "Insurance",
        6: "Origin local charge (including customs fee)",
        7: "Charged weight (only counting weight billing channels)",
        8: "Pure freight",
        9: "Single product pure feight cost",
        11: "Destination surcharge(Including customs clearance and delivery)"
      };
      return map[this.sortSel.indicators1];
    },
    firstChange() {
      if (this.sortSel.indicators === "Average") {
        this.sortSel.indicators1 = 2;
      } else {
        this.sortSel.indicators1 = 1;
      }
    },
    indicaChange(val) {
      // console.log("🚀 ~ val", val);
      if (this.sortSel.indicators1 === 2 || this.sortSel.indicators1 === 3) {
        this.sumDisabble = true;
        this.sortSel.indicators = "Average";
      } else {
        this.sumDisabble = false;
        this.sortSel.indicators = "Total";

        this.sortSel.indicators1 = val;
      }
    },

    swichOrder(i) {
      let staArr = this.sortSel.WaybillStatus;
      staArr.includes(i)
        ? staArr.splice(
          staArr.findIndex(v => v === i),
          1
        )
        : staArr.push(i);
    },

    //  获取图表数据  根据接口返回数据需要对它进行处理
    async getChartData() {
      let chartData;
      const secondData = () => {
        if (this.sortSel.indicators === "Average") return;
        const allType = [
          "Cost",
          "TotalAmount",
          "InsuranceAmount",
          "StartAreaAmount",
          "CusChargeWeight",
          "TraffAmount",
          "TraffAmountBySingle",
          "rate",
          "GoodValues",
          "DestAreaAmount",
          "WorkDay",
          "GoodValues",
          "Count"
        ];
        // debugger;
        allType.forEach(k => {
          if (k === "rate") {
            chartData[k].secondData = datasChild["Count"];
            chartData[k].firstData = chartData["rate"].series;
          } else {
            chartData[k].secondData = datasChild[k];
            chartData[k].firstData = chartData[k].series;
          }
        });
      };
      // debugger;
      // 转换参数
      const params = conversionParameters(this);
      //有孩子的3个tab
      const isChild = ["1", "20", "22"];
      // 图表的假数据

      //孩子数据
      let datasChild;
      const getEchart = async () => {
        const res = await getEcharts(
          this.$api03,
          params,
          this.activeChild - 0,
          this
        );
        // debugger;
        // 返回为空  不做处理
        if (!res) {
          if (this.sortSel.indicators1 === 1) {
            this.getJson = [
              {
                type: "bar",
                barWidth: 20,
                chartDatas: { series: [], sortTitle: [] },
                deliveryNum: { series: [], sortTitle: [] }
              },
              {
                type: "bar",
                barWidth: 20,
                chartDatas: { series: [], sortTitle: [] },
                deliveryNum: { series: [], sortTitle: [] }
              },
              {
                type: "pie",
                barWidth: 20,
                chartDatas: { series: [], sortTitle: [] },
                deliveryNum: { series: [], sortTitle: [] }
              }
            ];
          } else {
            // let lastData;
            // let amap = {
            //   4: chartDatas.GoodValues,
            //   5: chartDatas.InsuranceAmount,
            //   6: chartDatas.StartAreaAmount,
            //   7: chartDatas.CusChargeWeight,
            //   8: chartDatas.TraffAmount,
            //   9: chartDatas.TraffAmountBySingle
            // };
            // // debugger;
            // lastData = amap[this.sortSel.indicators1];
            this.getJson = [
              {
                type: "bar",
                barWidth: 20,
                chartDatas: { series: [], sortTitle: [] },
                deliveryNum: { series: [], sortTitle: [] }
              }
            ];
          }

          if (this.sortSel.indicators === "Average") {
            this.getJson = [
              {
                type: "bar",
                barWidth: 20,
                chartDatas: { series: [], sortTitle: [] },
                deliveryNum: { series: [], sortTitle: [] }
              }
            ];
          }
          return false;
        }
        // debugger;
        //这个3个页面有子集数据
        if (
          this.activeChild === "1" ||
          this.activeChild === "20" ||
          this.activeChild === "22"
        ) {
          chartData = res.charts;
          datasChild = res.datasChild;
          // console.log("🚀 ~ datasChild", datasChild);
        } else {
          chartData = res.charts;

          // datasChild = res.datasChild;
          // console.log("🚀 ~ datasChild", datasChild);
        }
        return true;
      };
      if (this.activeChild === "1,3,7,20") {
        // chartData = await getEcharts(this.$api03, params,undefined,this);
        // 如果为空数据
        if (!(await getEchart())) return;
        // chartData = toChartsFornat(dataSeries);
        // console.log("🚀 ~ chartData", chartData);
      }

      if (this.activeChild === "1") {
        if (!(await getEchart())) return;

        secondData();
      }

      //如果为空运 , 只渲染最大的数据. 点击图 显示全部
      // debugger;
      if (this.activeChild === "3") {
        // console.log("🚀 ~ chartData", chartData);
        if (!(await getEchart())) return;
      }
      //specialLine
      if (this.activeChild === "22") {
        // console.log("🚀 ~ chartData", chartData);
        if (!(await getEchart())) return;

        secondData();
      }
      if (this.activeChild === "20") {
        if (!(await getEchart())) return;

        secondData();
        // console.log("🚀 ~ chartData", chartData);
        // chartData = toChartsFornat(dataSeries);
      }
      //各指标展示不同的数据
      const allType = {
        5: "InsuranceAmount",
        6: "StartAreaAmount",
        7: "CusChargeWeight",
        8: "TraffAmount",
        9: "TraffAmountBySingle",
        4: "GoodValues",
        11: "DestAreaAmount",
        2: "WorkDay",
        3: "WorkDay",
        1: "Count"
      };
      if (this.sortSel.indicators1 === 1) {
        //
        // 有3个有孩子数据,展示在发货总数
        this.getJson = [
          {
            type: "bar",
            barWidth: 20,
            chartDatas: chartData.TotalAmount,
            // ? chartData[this.sortSel.indicators1]
            deliveryNum: isChild.includes(this.activeChild)
              ? chartData.Count
              : chartData.Count
          },
          {
            type: "bar",
            barWidth: 20,
            chartDatas: chartData.Cost,
            // chartData: chartData.Cost,
            deliveryNum: chartData.Count
          },
          {
            type: "pie",
            barWidth: 20,
            chartDatas:
              this.activeChild !== "1,3,7,20"
                ? chartData.rate
                : chartData.Count,
            deliveryNum: chartData.Count
          }
        ];
      } else {
        let lastData;
        // let amap = {
        //   4: chartData.GoodValues,
        //   5: chartData.InsuranceAmount,
        //   6: chartData.StartAreaAmount,
        //   7: chartData.CusChargeWeight,
        //   8: chartData.TraffAmount,
        //   9: chartData.TraffAmountBySingle
        // };
        // debugger;
        lastData = chartData[allType[this.sortSel.indicators1]];
        this.getJson = [
          {
            type: "bar",
            barWidth: 20,
            chartDatas: lastData,
            deliveryNum: lastData
          }
          // {
          //   type: "bar",
          //   barWidth: 20,
          //   chartData: lastData,
          //   deliveryNum: lastData
          // },
          // {
          //   type: "pie",
          //   barWidth: 20,
          //   chartData:
          //     this.activeChild !== "1,3,7,20" ? chartData.rate : lastData,
          //   deliveryNum: lastData
          // }
        ];
      }

      if (this.sortSel.indicators === "Average") {
        this.getJson = [
          {
            type: "bar",
            barWidth: 20,
            chartDatas: chartData.WorkDay,
            deliveryNum: chartData.WorkDay
          }
        ];
      }
      console.log("🚀 ~ this.getJson ", this.getJson);
    },
    getOption() {
      this.indicatorsOpt = [
        {
          value: "Total"
        },
        {
          value: "Average"
        }
      ];
      const inArrMap = {
        "1,3,7,20": [
          {
            value: 1,
            label: "Main indicators"
          },
          {
            value: 2,
            label: "Average age (after pickup)"
          },
          {
            value: 3,
            label: "Average age (after departure)"
          },
          {
            value: 8,
            label: "Pure freight"
          }
        ],
        "1": [
          {
            value: 1,
            label: "Main indicators"
          },
          {
            value: 7,
            label: "Charged weight (only counting weight billing channels)"
          },
          {
            value: 2,
            label: "Average age (after pickup)"
          },
          {
            value: 3,
            label: "Average age (after departure)"
          },
          {
            value: 4,
            label: "Declared value"
          },
          {
            value: 5,
            label: "Insurance"
          },
          {
            value: 6,
            label: "Origin local charge (including customs fee)"
          },
          {
            value: 8,
            label: "Pure freight"
          },
          {
            value: 9,
            label: "Single product pure feight cost"
          }
        ],
        "3": [
          {
            value: 1,
            label: "Main indicators"
          },
          {
            value: 7,
            label: "Charged weight (only counting weight billing channels)"
          },
          {
            value: 2,
            label: "Average age (after pickup)"
          },
          {
            value: 3,
            label: "Average age (after departure)"
          },

          {
            value: 5,
            label: "Insurance"
          },
          {
            value: 6,
            label: "Origin local charge (including customs fee)"
          },
          {
            value: 11,
            label: "Destination surcharge(Including customs clearance and delivery)"
          },
          {
            value: 8,
            label: "Pure freight"
          }
        ],
        "20": [
          {
            value: 1,
            label: "Main indicators"
          },
          {
            value: 7,
            label: "Charged weight (only counting weight billing channels)"
          },
          {
            value: 2,
            label: "Average age (after pickup)"
          },
          {
            value: 3,
            label: "Average age (after departure)"
          },

          {
            value: 5,
            label: "Insurance"
          },
          {
            value: 6,
            label: "Origin local charge (including customs fee)"
          },
          {
            value: 8,
            label: "Pure freight"
          },
          {
            value: 9,
            label: "Single product pure feight cost"
          }
        ],
        "22": [
          {
            value: 1,
            label: "Main indicators"
          },
          {
            value: 7,
            label: "Charged weight (only counting weight billing channels)"
          },
          {
            value: 2,
            label: "Average age (after pickup)"
          },
          {
            value: 3,
            label: "Average age (after departure)"
          },

          {
            value: 5,
            label: "Insurance"
          },
          {
            value: 6,
            label: "Origin local charge (including customs fee)"
          },
          {
            value: 8,
            label: "Pure freight"
          },
          {
            value: 9,
            label: "Single product pure feight cost"
          }
        ]
      };
      this.indicatorsOpt1 = inArrMap[this.activeChild];
    },
    async getSort() {
      // let cityOptions = await getContry(this.$api02);
      // let countryOptions = await getCity(this.$api02);
      let [
        countryOptions,
        cityOptions,
        airportOptions,
        store,
        startAirportOptions
      ] = await Promise.all([
        getContry(this.$api02),
        getCity(this.$api02),
        getAirport(this.$api02),
        getStore(this.$api02),
        getStartAirport(this.$api04)
      ]);
      // //城市
      // debugger;
      //联系人
      let consignorOptions = [];
      let city = {
        placeholder: "Departure city",
        value: "city", //绑定sortSel里的city字段
        width: 185,
        type: "select",
        options: cityOptions
      };
      let country = {
        placeholder: "destination country",
        value: "country",
        width: 185,
        type: "select",
        options: countryOptions
      };
      let consignee = {
        placeholder: "Consignee",
        value: "consignee",
        width: 150,
        type: "select",
        options: cityOptions
      };
      let consignor = {
        placeholder: "Consignor",
        value: "consignor",
        width: 150,
        type: "select",
        options: consignorOptions
      };
      let amazon = {
        placeholder: "AmazonWarehouse",
        value: "amazon",
        width: 200,
        type: "select",
        options: store
      };
      let startAirport = {
        placeholder: "Departure airport",
        value: "startAirport",
        width: 150,
        type: "select",
        options: startAirportOptions
      };
      let endAirport = {
        placeholder: "Destination airport",
        value: "endAirport",
        width: 150,
        type: "select",
        options: airportOptions
      };
      let deliveryTm = {
        placeholder: "DeliveryTime",
        type: "date",
        value: "deliveryTm"
      };
      let completeTm = {
        placeholder: "CompletionTime",
        type: "date",
        value: "completeTm"
      };
      // 总览： 起运城市 city， 目的国家 country， 收货人 consignee， 发货人 consignor
      // 快递： 起运城市， 目的国家， 收货人， 发货人
      // 空运： 起运机场 startAirport， Destination airport endAirport， 目的国家 收货人， 发货人
      // FBA： 起运城市， 目的国家，  AmazonWarehouse amazon， 收货人， 发货人
      // specialLine： 起运城市， 目的国家， 收货人， 发货人
      if (this.activeChild === "1,3,7,20") {
        this.sortData = [city, country, consignee, consignor];
      }
      if (this.activeChild === "1") {
        this.sortData = [city, country, consignee, consignor];
      }
      if (this.activeChild === "3") {
        this.sortData = [
          startAirport,
          endAirport,
          country,
          consignee,
          consignor
        ];
      }
      if (this.activeChild === "20") {
        this.sortData = [city, country, amazon, consignee, consignor];
      }
      if (this.activeChild === "22") {
        this.sortData = [city, country, consignee, consignor];
      }
    },
    // Download
    exportImg() {
      this.getPdf("exportpdf", "Order analysis");
    },
    handleClick() {
      this.sortSel = JSON.parse(JSON.stringify(defaultVal));
      this.getAjax();
      this.sumDisabble = false;
      // this.getOption(); // 获取Statistical indicators
    },
    // 假数据
    getAjax() {
      this.getChartData(); // 获取图表数据
      this.getOption(); // 获取Statistical indicators
      this.getSort(); //获取分类数据
    }
  }
};
</script>
<style></style>
<style scoped>
/*-----------头部标题切换样式------------------*/
/* @import "../../../../static/css/userCenterList.css"; */
.statement {
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
}
.m-head {
  padding-left: 30px;
}
.m-headWrap {
  height: 40px;
  position: relative;
  border-bottom: 1px solid #e8e8e8;
}
.m-sortWarp {
  padding: 10px 0 15px 30px;

  background: #f6f6f6;
}
.m-sortWarp li {
  /* height: 30px; */
  line-height: 30px;
}
.m-fromWarp {
  padding: 20px 0 20px 0;
  position: relative;
}
.u-stateBtn {
  border: 1px solid #d9d9d9;
  height: 28px;
  border-radius: 5px;
  overflow: hidden;
}
.u-stateBtn li {
  width: 59px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  text-align: center;
  background: white;
  border-right: 1px solid #d9d9d9;
  color: #434343;
}
.u-stateBtn li:last-child {
  border-right: 0px;
}
.u-stateBtn .activeState {
  background: #0c5ee5;
  color: #ffffff;
}
.u-sortBtn-list {
  display: inline-block;
  width: 800px;
}
.u-sortBtn {
  margin-left: 13px;
  padding-bottom: 5px;
  /* width: 120px; */
}
.u-line {
  height: 4px;
  background: #ededed;
}
.u-change {
  position: absolute;
  width: 100%;
  top: 20px;
  z-index: 999;
}
.u-change .title {
  font-size: 14px;
  color: black;
  font-weight: bold;
  margin-left: 30px;
  letter-spacing: 0.5px;
}
.u-change .change {
  font-size: 12px;
  color: black;
  margin-right: 110px;
}
.u-change .label {
  margin-right: 10px;
}
.checkLabel {
  line-height: 16px;
  font-size: 12px;
}
.exportBtn {
  width: 68px;
  height: 28px;
  border: 1px solid #0c5ee4;
  background: #0c5ee4;
  color: #fff;
  border-radius: 25px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.u-tip {
  position: absolute;
  right: 45px;
  /* line-height: 45px; */
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/orderAnalysis.vue